import Axios from "axios";
import QS from "qs";
import Feng from "@/api/Feng.js";

Axios.defaults.timeout = 5000;
Axios.defaults.baseURL = Feng.BASE_URL;

Axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

Axios.interceptors.response.use(
  response => {
    if (response.status == 200) {
      if (response.data.status == 401) {
        window.location.href = Feng.BASE_URL + "/wechatLogin/loginInit";
      } else {
        return Promise.resolve(response.data);
      }
    } else {
      return Promise.reject(response);
    }
  },
  err => {
    return Promise.reject(err);
  }
);

export const get = (url, params) => {
  return new Promise((resolve, reject) => {
    Axios.get(url, { params: params })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const post = (url, params) => {
  return new Promise((resolve, reject) => {
    Axios.post(url, QS.stringify(params))
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
